export default () => ({
    items: "",
});
